import script from "./QuillView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuillView.vue?vue&type=script&setup=true&lang=js"

import "./QuillView.vue?vue&type=style&index=0&id=5b7af212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b7af212"]])

export default __exports__